// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apartment-status[data-v-e2e278fc] {\n  padding: 4px;\n  border-radius: 4px;\n  font-weight: bold;\n}\n.apartment-status.EMPTY[data-v-e2e278fc] {\n    background: #fbc02d;\n    color: black;\n}\n.apartment-status.FILL[data-v-e2e278fc] {\n    background: #4caf50;\n    color: #fff;\n}\n.apartment-status.BLOCK[data-v-e2e278fc] {\n    background: #ef4f2a;\n    color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
